/* GoGo Solar - welcome offer popup.

   WHEN IT SHOWS - CHANGED 4 OCTOBER 2026

   Hussein: "I want this to only pop up at the start of the home page. I
   dont want it to keep popping up every so often as it gets annoying."

   It now shows ONLY on the homepage, and only once per visitor per 30
   days, counted from the moment it is SHOWN. Seeing it and closing it is
   enough to stop it coming back. A completed signup silences it for good.

   That is a deliberate reversal of the previous behaviour, which showed it
   on EVERY page load everywhere except cart and checkout, and only stopped
   after a signup. That version was written to fix the opposite complaint -
   it used to hide for 45 days the moment it was opened once, so people who
   closed it by accident never saw the offer again. Both extremes were
   wrong. Shown-once-per-30-days, homepage only, is the middle.

   If it ever needs tuning, the three dials are at the top: HOMEPAGE_ONLY,
   SHOWN_DAYS and DELAY.

   Still suppressed on cart and checkout so it cannot interrupt a purchase.

   HOW THE SIGNUP WORKS

   The popup does not post anything itself. It copies the address into the
   real Liquid customer form rendered by snippets/bsl-real-forms.liquid and
   submits that. An earlier version built its own form and posted it with
   fetch(), which failed with 400 "Missing CAPTCHA token" every time while
   telling the visitor it had worked. The captcha is off at the moment, but
   the hand-off stays: it is what keeps this working if it is turned back on.

   Success is taken only from Shopify's own answer, published as data-ok on
   #bsl-real-customer-result. Never from ?customer_posted=true in the
   address bar - that came back on a submission that created nothing.

   THE DISCOUNT CODE IS NEVER SHOWN ON SCREEN. It is unique per subscriber,
   generated by Seguno at send time, and only ever arrives by email.

   Add ?popup=1 to any URL to force it open for testing - that bypasses the
   homepage and once-per-30-days rules. */
(function () {
  var HOMEPAGE_ONLY = true;
  var SHOWN_DAYS = 30;
  var DELAY = 4000;

  var SIGNED = "bsl-welcome-signed";
  var SHOWN = "bsl-welcome-shown";
  var PENDING = "bsl-welcome-pending";

  var FORCE = /[?&]popup=1/.test(location.search);

  var GOLD = "#F5A800";
  var INK = "#171A15";
  var MIST = "#EEF0EB";

  var PHOTO =
    "https://cdn.shopify.com/s/files/1/1011/9715/2638/files/" +
    "hf_20260726_231017_e08f1ab2-ec35-4c8e-b019-361eccccbf1b.png?v=1785107505&width=900";

  var node = null;
  var dismissed = false;

  /* ---------- the rules ---------- */

  function onHomepage() {
    var p = location.pathname.replace(/\/+$/, "");
    return p === "" || p === "/index";
  }

  function signedUp() {
    if (FORCE) return false;
    try { return localStorage.getItem(SIGNED) === "1"; } catch (e) { return false; }
  }

  function markSignedUp() {
    try { localStorage.setItem(SIGNED, "1"); } catch (e) {}
  }

  /* shown is separate from signed on purpose: signed means "joined the
     list", shown means "has been asked". Conflating them is what produced
     the old behaviour where closing it did nothing. */
  function recentlyShown() {
    if (FORCE) return false;
    try {
      var t = parseInt(localStorage.getItem(SHOWN) || "0", 10);
      if (!t) return false;
      return Date.now() - t < SHOWN_DAYS * 24 * 60 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  function markShown() {
    try { localStorage.setItem(SHOWN, String(Date.now())); } catch (e) {}
  }

  function blocked() {
    var p = location.pathname;
    return /\/(cart|checkouts?|account|challenge)/.test(p) || /\/thank[_-]?you/.test(p);
  }

  function pendingEmail() {
    try { return sessionStorage.getItem(PENDING); } catch (e) { return null; }
  }

  function setPending(v) {
    try {
      if (v === null) sessionStorage.removeItem(PENDING);
      else sessionStorage.setItem(PENDING, v);
    } catch (e) {}
  }

  function verdict() {
    var el = document.getElementById("bsl-real-customer-result");
    if (!el) return null;
    return {
      ok: el.getAttribute("data-ok") === "1",
      msg: el.getAttribute("data-msg") || ""
    };
  }

  function styles() {
    if (document.getElementById("bsl-pop-style")) return;
    var s = document.createElement("style");
    s.id = "bsl-pop-style";
    s.textContent = [
      "#bsl-pop{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;" +
        "justify-content:center;padding:1.25rem;background:rgba(12,14,11,.62);" +
        "backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);" +
        "opacity:0;visibility:hidden;transition:opacity .32s ease,visibility .32s;" +
        "font-family:Inter,system-ui,sans-serif}",
      "#bsl-pop.open{opacity:1;visibility:visible}",

      "#bsl-pop .box{position:relative;width:100%;max-width:44rem;background:#fff;" +
        "border-radius:24px;overflow:hidden;display:grid;grid-template-columns:1fr;" +
        "box-shadow:0 40px 90px rgba(12,14,11,.45);transform:translateY(14px) scale(.985);" +
        "transition:transform .32s cubic-bezier(.2,.8,.3,1)}",
      "#bsl-pop.open .box{transform:none}",
      "@media(min-width:760px){#bsl-pop .box{grid-template-columns:1fr 1fr}}",

      "#bsl-pop .shot{display:none;background:#0F1210 center/cover no-repeat}",
      "@media(min-width:760px){#bsl-pop .shot{display:block;min-height:24rem}}",

      "#bsl-pop .pad{padding:2.4rem 2rem 2rem}",
      "@media(min-width:760px){#bsl-pop .pad{padding:2.75rem 2.4rem}}",

      "#bsl-pop .eyebrow{display:block;font-size:.68rem;font-weight:700;letter-spacing:.2em;" +
        "text-transform:uppercase;color:" + GOLD + ";margin-bottom:.9rem}",
      "#bsl-pop h2{font-family:Satoshi,ui-sans-serif,system-ui,sans-serif;font-weight:900;" +
        "font-size:2rem;line-height:1.05;letter-spacing:-.03em;color:" + INK + ";margin:0}",
      "#bsl-pop h2 em{font-style:normal;color:" + GOLD + "}",
      "#bsl-pop p.lede{margin:.9rem 0 0;font-size:.92rem;line-height:1.6;color:#5F6259}",

      "#bsl-pop ul{list-style:none;margin:1.3rem 0 0;padding:0;display:grid;gap:.5rem}",
      "#bsl-pop li{display:flex;align-items:flex-start;gap:.6rem;font-size:.86rem;color:" + INK + "}",
      "#bsl-pop li i{font-style:normal;color:" + GOLD + ";font-weight:700;line-height:1.5}",

      "#bsl-pop form{display:flex;gap:.55rem;margin-top:1.6rem;flex-wrap:wrap}",
      "#bsl-pop input{flex:1 1 11rem;min-width:0;border:1px solid rgba(23,26,21,.18);" +
        "border-radius:999px;padding:.85rem 1.1rem;font-size:.9rem;font-family:inherit;" +
        "color:" + INK + ";background:#fff}",
      "#bsl-pop input:focus{outline:2px solid " + GOLD + ";outline-offset:1px;border-color:transparent}",
      "#bsl-pop button.go{flex:0 0 auto;border:0;border-radius:999px;cursor:pointer;" +
        "background:" + GOLD + ";color:" + INK + ";font-weight:800;font-size:.86rem;" +
        "padding:.85rem 1.5rem;font-family:Satoshi,ui-sans-serif,system-ui,sans-serif;" +
        "transition:background .2s ease}",
      "#bsl-pop button.go:hover{background:#FFC94D}",
      "#bsl-pop button.go[disabled]{opacity:.6;cursor:default}",
      "#bsl-pop .small{margin:.9rem 0 0;font-size:.72rem;color:#8A8D83}",
      "#bsl-pop .err{margin:.7rem 0 0;font-size:.78rem;color:#B4342B;display:none}",

      "#bsl-pop .done{display:none;margin-top:1.5rem}",
      "#bsl-pop .inbox{display:flex;align-items:flex-start;gap:.9rem;background:" + MIST + ";" +
        "border:1px solid rgba(23,26,21,.1);border-radius:14px;padding:1.1rem 1.2rem}",
      "#bsl-pop .inbox .tick{flex:0 0 auto;width:26px;height:26px;border-radius:999px;" +
        "background:" + GOLD + ";color:" + INK + ";font-weight:800;font-size:.85rem;" +
        "display:flex;align-items:center;justify-content:center}",
      "#bsl-pop .inbox p{margin:0;font-size:.86rem;line-height:1.55;color:" + INK + "}",
      "#bsl-pop .inbox p span{display:block;margin-top:.35rem;font-size:.76rem;color:#6E7268}",

      "#bsl-pop .x{position:absolute;top:.85rem;right:.9rem;z-index:3;width:34px;height:34px;" +
        "border:0;border-radius:999px;background:rgba(255,255,255,.9);color:" + INK + ";" +
        "font-size:1.2rem;line-height:1;cursor:pointer;box-shadow:0 3px 12px rgba(12,14,11,.18)}",
      "#bsl-pop .x:hover{background:#fff}",

      "@media(prefers-reduced-motion:reduce){#bsl-pop,#bsl-pop .box{transition:none}}"
    ].join("");
    document.head.appendChild(s);
  }

  function build() {
    var d = document.createElement("div");
    d.id = "bsl-pop";
    d.setAttribute("role", "dialog");
    d.setAttribute("aria-modal", "true");
    d.setAttribute("aria-label", "10% off your first order");
    d.innerHTML =
      '<div class="box">' +
        '<button class="x" type="button" aria-label="Close">×</button>' +
        '<div class="shot" style="background-image:url(' + PHOTO + ')"></div>' +
        '<div class="pad">' +
          '<span class="eyebrow">Welcome</span>' +
          "<h2>Take <em>10% off</em> your first order.</h2>" +
          '<p class="lede">Join the list and we’ll email your code straight over.</p>' +
          "<ul>" +
            "<li><i>✓</i><span>10% off your first order</span></li>" +
            "<li><i>✓</i><span>Your own code, good for 30 days</span></li>" +
            "<li><i>✓</i><span>Early access to new products</span></li>" +
          "</ul>" +
          '<form novalidate>' +
            '<input type="email" name="email" required autocomplete="email" ' +
              'placeholder="Your email address" aria-label="Your email address">' +
            '<button class="go" type="submit">Email my code</button>' +
          "</form>" +
          '<p class="err"></p>' +
          '<p class="small">New subscribers only. One code per email address.</p>' +
          '<div class="done">' +
            '<div class="inbox"><div class="tick">✓</div>' +
              "<p>You’re in — check your inbox." +
                "<span>Your code is on its way and is valid for 30 days. " +
                "If it hasn’t arrived in a few minutes, have a look in spam.</span></p>" +
            "</div>" +
          "</div>" +
        "</div>" +
      "</div>";
    return d;
  }

  function attach() {
    if (!node || dismissed) return;
    if (!document.body.contains(node)) document.body.appendChild(node);
  }

  function open() {
    attach();
    if (!node) return;
    node.classList.add("open");
    markShown();
    var input = node.querySelector("input");
    setTimeout(function () { if (input) try { input.focus(); } catch (e) {} }, 340);
  }

  function close() {
    dismissed = true;
    if (!node) return;
    node.classList.remove("open");
    setTimeout(function () {
      if (node && node.parentNode) node.parentNode.removeChild(node);
      node = null;
    }, 400);
  }

  function showDone() {
    if (!node) return;
    var form = node.querySelector("form");
    var small = node.querySelector(".small");
    var done = node.querySelector(".done");
    if (form) form.style.display = "none";
    if (small) small.style.display = "none";
    if (done) done.style.display = "block";
  }

  function showError(msg) {
    if (!node) return;
    var err = node.querySelector(".err");
    if (!err) return;
    err.textContent = msg ||
      "Something went wrong sending that. Please try again, or email " +
      "info@gogosolar.co.uk and we’ll sort it.";
    err.style.display = "block";
  }

  function handOff(email) {
    var form = document.getElementById("bsl-real-customer-form");
    var field = document.getElementById("bsl-real-customer-email");
    if (!form || !field) return false;
    field.value = email;
    setPending(email);
    try {
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        var btn = form.querySelector('button[type="submit"],input[type="submit"]');
        if (btn) btn.click(); else return false;
      }
      return true;
    } catch (e) {
      setPending(null);
      return false;
    }
  }

  function wire(d) {
    var form = d.querySelector("form");
    var input = d.querySelector("input");
    var btn = d.querySelector("button.go");
    var err = d.querySelector(".err");

    d.querySelector(".x").addEventListener("click", close);
    d.addEventListener("click", function (e) { if (e.target === d) close(); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && node && node.classList.contains("open")) close();
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = (input.value || "").trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        err.textContent = "Please enter a valid email address.";
        err.style.display = "block";
        input.focus();
        return;
      }
      err.style.display = "none";
      btn.disabled = true;
      btn.textContent = "Sending…";

      if (!handOff(email)) {
        btn.disabled = false;
        btn.textContent = "Email my code";
        showError(
          "The signup form did not load on this page, so nothing was sent. " +
          "Please email info@gogosolar.co.uk and we’ll add you by hand."
        );
      }
    });
  }

  function start() {
    if (blocked() || node) return;

    var v = verdict();
    var waiting = pendingEmail();
    var returning = !!(v && waiting);

    /* returning from a real signup always shows, so the visitor learns
       whether it worked. everything else goes through the rules. */
    if (!returning) {
      if (signedUp()) return;
      if (HOMEPAGE_ONLY && !FORCE && !onHomepage()) return;
      if (recentlyShown()) return;
    }

    styles();
    node = build();
    document.body.appendChild(node);
    wire(node);

    new MutationObserver(attach).observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    if (returning) {
      setPending(null);
      if (v.ok) {
        markSignedUp();
        showDone();
      } else {
        showError(v.msg);
      }
      open();
      return;
    }

    setTimeout(open, FORCE ? 400 : DELAY);
  }

  if (document.readyState !== "loading") start();
  else document.addEventListener("DOMContentLoaded", start);
  window.addEventListener("load", function () { styles(); attach(); });
})();
